var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pt-xl-1 bg-gray2 d-xl-flex" }, [
    _c(
      "div",
      { staticClass: "row px-1" },
      [
        _c(
          "h4",
          { staticClass: "col-12 col-xl-3 px-1 mb-0 pe-xl-0 ps-xl-2 py-xl-2" },
          [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]
        ),
        _vm._v(" "),
        _c("ob1-picture", {
          staticClass: "col-12 col-xl-6 ps-1 pe-0 py-0 justify-content-center",
          attrs: {
            visual: _vm.picture,
            "css-classes": "device-value-help-img px-xl-1",
          },
        }),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "col-12 col-xl-3 px-1 mb-0 ps-xl-0 pe-xl-2 py-xl-2 align-self-lg-end lead",
          },
          [_c("strong", [_vm._v(_vm._s(_vm.text))])]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }